<template>
    <div class="bgimg">
        <div class="topleft">
        </div>
        <div class="middle">
          <!-- <img alt="CESO logo" src="https://theceso.com/wp-content/uploads/2019/08/newlogo.png" /> -->
          <h1>Development Homepage</h1>
          <h1>COMING SOON</h1>
          <hr>
          <p> {{ this.time }}</p>
        </div>
        <div class="bottom">
            <!-- use router-link component for navigation. -->
            <!-- specify the link by passing the `to` prop. -->
            <!-- <router-link> will be rendered as an `<a>` tag by default -->
            <b-row md="12">
              <b-col md='4' class="mt-4">
                <router-link to="/">
                  <formulateInput label="Home" type="button"/>
                </router-link>
              </b-col>
              <b-col md='4' class="mt-4">
                <router-link to="/RequestForm">
                  <formulateInput label="Request Form" type="button"/>
                </router-link>
              </b-col>
              <b-col md='4' class="mt-4">
                <router-link to="/DailyNoShowForm">
                  <formulateInput label="Daily No-show Form" type="button"/>
                </router-link>
              </b-col>
              <b-col md='4' class="mt-4">
                <router-link to="/CalendarForm">
                  <formulateInput label="Calendar Form" type="button"/>
                </router-link>
              </b-col>
              <b-col md='4' class="mt-4">
                <router-link to="/StudentList">
                  <formulateInput label="Student List" type="button"/>
                </router-link>
              </b-col>
              <b-col md='4' class="mt-4">
                <router-link to="/CancelForm">
                  <formulateInput label="Cancellation Request" type="button"/>
                </router-link>
              </b-col>
              <b-col md='4' class="mt-4">
                <router-link to="/OneTimeNoRide">
                  <formulateInput label="One Time No Ride Form" type="button"/>
                </router-link>
              </b-col>
            </b-row>
            <!-- route outlet -->
            <!-- component matched by the route will render here -->
          </div>
        <div class="bottomleft">
            <!-- <p>Some text</p> -->
        </div>
    </div>
</template>
<script>
export default {
  props: {
    user: {},
  },
  data() {
    return {
      interval: null,
      time: null
    }
  },
  beforeUnmount() {
    // prevent memory leak
    clearInterval(this.interval)
  },
  created() {
    // update the time every second
    this.interval = setInterval(() => {
      // Concise way to format time according to system locale.
      // In my case this returns "3:48:00 am"
      this.time = new Date()
    }, 1000)
  }
}

</script>


<style>
/* Set height to 100% for body and html to enable the background image to cover the whole page: */
body, html {
  height: 100%
}

.bgimg {
  /* Background image */
  background-image: url('https://www.thebalancecareers.com/thmb/hKctLkuZxqFGd3XpQCUjQBjSPjQ=/3436x2577/smart/filters:no_upscale()/school-books-on-desk--education-concept-871454068-5b548900c9e77c005b04fc8c.jpg');
  /* Full-screen */
  height: 100%;
  /* Center the background image */
  background-position: center;
  /* Scale and zoom in the image */
  background-size: cover;
  /* Add position: relative to enable absolutely positioned elements inside the image (place text) */
  position: relative;
  /* Add a white text color to all elements inside the .bgimg container */
  color: white;
  /* Add a font */
  font-family: "Courier New", Courier, monospace;
  /* Set the font-size to 25 pixels */
  font-size: 25px;
}

/* Position text in the top-left corner */
.topleft {
  position: absolute;
  top: 0;
  left: 16px;
}

/* Position text in the bottom-left corner */
.bottomleft {
  position: absolute;
  bottom: 0;
  left: 16px;
}

/* Position text in the middle */
.middle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

/* Style the <hr> element */
hr {
  margin: auto;
  width: 40%;
}
</style>
